import { tokens, WHITE } from '@airtel/air-design-system';
import { StyleSheet } from 'react-native';
export var getCommonMobilityStepCardWidgetStyles = internalIsExpanded => {
  var borderRadiusToken = tokens.borderRadius.BORDER_RADIUS_16;
  var spacingToken = tokens.spacing;
  return StyleSheet.create({
    stepCard: {
      borderRadius: borderRadiusToken,
      borderColor: WHITE,
      width: '100%',
      marginBottom: spacingToken.SPACING_20,
      paddingTop: internalIsExpanded ? spacingToken.SPACING_8 : spacingToken.SPACING_4,
      paddingBottom: internalIsExpanded ? spacingToken.SPACING_16 : spacingToken.SPACING_4
    },
    collapsibleContainer: {
      width: '100%'
    },
    linkListWidget: {
      borderRadius: borderRadiusToken
    },
    omniWidgetTopMargin: {
      margin: spacingToken === null || spacingToken === void 0 ? void 0 : spacingToken.SPACING_0,
      paddingTop: spacingToken === null || spacingToken === void 0 ? void 0 : spacingToken.SPACING_12
    },
    radioGroupWidgetTopMargin: {
      paddingTop: spacingToken === null || spacingToken === void 0 ? void 0 : spacingToken.SPACING_12
    }
  });
};